<template>
  <div>
    <h1 class="common__main-title">Edit Schedule</h1>
    <div class="common__sub-title">
      <span>Edit</span>
    </div>
    <TutorInfo :tutor="tutor"/>
    <div class="content-wrapper">
      <ConfirmForm :schedule="schedule"/>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'EditSchedule',
            params: { editingSchedule: this.$route.params.editingSchedule }
          }"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="update"
        >
          Edit
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import TutorInfo from '@/components/parts/TutorInfo.vue';
import ConfirmForm from '@/components/parts/schedules/ConfirmForm.vue'
import { Tutor } from '@/store/tutors/types'
import { Schedule } from '@/store/schedules/types'
import Loading from '@/components/parts/modal/Loading.vue'

export default Vue.extend({
  components: {
    TutorInfo,
    ConfirmForm,
    Loading,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    schedule(): Schedule {
      const schedule: Schedule = JSON.parse(this.$route.params.editingSchedule)
      return {
        ...schedule,
        date: moment(schedule.date),
        from: moment(schedule.from),
        to: moment(schedule.to),
      }
    },
    tutor(): Tutor {
      return _.set(this.schedule.tutor, 'hireDate', moment(this.schedule.tutor.hireDate))
    },
  },

  methods: {
    async update() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      try {
        await this.$store.dispatch('updateSchedule', { schedule: this.schedule })
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')

        this.$router.push({
          name: 'EditSchedule',
          params: {
            tutorId: this.tutor.id,
            scheduleId: this.schedule.id,
          },
        })
      } catch (error: any) {
        this.isLoading = false
        const message = error.response?.data?.message || error
        await this.$bvModal.msgBoxOk(`Error - ${message}`)
        this.$router.push({
          name: 'EditSchedule',
          params: {
            tutorId: this.tutor.id,
            editingSchedule: this.$route.params.editingSchedule,
          },
        })
      }
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}
</style>
